const ENABLED_WIDTHS = [
  320,
  640,
  960,
  1280,
  1600,
  1920,
  2240,
  2560,
  2880,
  3200,
  3520,
  3840,
  4160
];
const MIN_INTERVALS = 4;
function generateSrcSet(src, maxWidth, widths = ENABLED_WIDTHS) {
  const limitedWidths = (() => {
    const limitedWidths2 = widths.filter((it) => it <= (maxWidth ?? Infinity));
    if (maxWidth && (limitedWidths2[limitedWidths2.length - 1] ?? 0) < maxWidth) {
      limitedWidths2.push(maxWidth);
    }
    if (limitedWidths2.length < MIN_INTERVALS && maxWidth) {
      return new Array(MIN_INTERVALS).fill(void 0).map((_, index) => {
        const step = maxWidth / MIN_INTERVALS;
        return Math.round(step * (index + 1));
      });
    }
    return limitedWidths2;
  })();
  return limitedWidths.map((it) => `${src}${(src == null ? void 0 : src.includes("?")) ? "&" : "?"}w=${it} ${it}w`).join(", ");
}

export { generateSrcSet };
//# sourceMappingURL=image.generate-src-set.js.map
